import { BlockRequestRequest, GetBlockRequestResponse } from "@/services/block-request-registration/blockRequestService";

export function useBlockRequest() {
  const blockRequest = async (req: BlockRequestRequest) => {
    const result = await fetch("/api/block-request", {
      body: JSON.stringify(req),
      method: "POST",
    });
    const { data } = await result.json();
    const resultJson = data as GetBlockRequestResponse;
    return resultJson;
  };
  return blockRequest;
}